<template>
    <div class="card_main">
        <div class="head">
            <span class="head_title">大湘速聘 - 学习中心</span>
            <div>
                <span class="login" @click="(login_show = true)">登录</span>
                <span class="login" @click="(regit_show = true)" style="margin-left:10px;">注册</span>
            </div>
        </div>
        <div class="new_main">
            <div v-for="(item, i) in news_list" :key="i" class="newcard" @click="click_news(item)">
                <div class="card_title">
                    {{ item.title }}
                </div>
                <div>
                    {{ item.value }}
                </div>
                <div class="price">
                    {{ item.price }}
                </div>
                <div class="time2">
                    上传时间：{{ item.time }}
                </div>
            </div>
        </div>
        <div class="gengduo" @click="gengduo2">
            查看更多
        </div>

        <div class="floor">
            <div class="kefu2">
                <span class="kefu3">客服：kefu@daxiangsys.com</span>
                <a target="_black" href="https://beian.miit.gov.cn/" class="kefu13">湘ICP备2022000332号-1</a>
                <span class="kefu3">Copyright © 2022 大湘人力资源集团.</span>
                <a target="_black" href="https://beian.miit.gov.cn/" class="kefu13">湘公网安备430190020016</a>


            </div>
            <div class="kefu2">
                <span>地址：长沙高新开发区麓谷大道627号海创科技工业园B-2栋加速器生产车间702</span>
            </div>

        </div>

        <Modal v-model="login_show" title="登录" :footer-hide="true">
            <div class="login_box">
                <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
                    <div>

                        <FormItem prop="user">
                            <Input type="text" v-model="formInline.user" placeholder="请输入帐号">
                            <template #prepend>
                                <Icon type="ios-person-outline"></Icon>
                            </template>
                            </Input>
                        </FormItem>
                    </div>
                    <div>
                        <FormItem prop="password">
                            <Input type="password" v-model="formInline.password" placeholder="请输入密码">
                            <template #prepend>
                                <Icon type="ios-lock-outline"></Icon>
                            </template>
                            </Input>
                        </FormItem>
                    </div>
                    <FormItem>
                        <Button type="primary" @click="handleSubmit('formInline')">登录</Button>

                    </FormItem>
                </Form>
            </div>


        </Modal>

        <Modal v-model="regit_show" title="注册" :footer-hide="true">
            <div class="login_box">
                <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
                    <div>

                        <FormItem prop="user">
                            <Input type="text" v-model="formInline.user" placeholder="请输入帐号">
                            <template #prepend>
                                <Icon type="ios-person-outline"></Icon>
                            </template>
                            </Input>
                        </FormItem>
                    </div>
                    <div>
                        <FormItem prop="password">
                            <Input type="password" v-model="formInline.password" placeholder="请输入密码">
                            <template #prepend>
                                <Icon type="ios-lock-outline"></Icon>
                            </template>
                            </Input>
                        </FormItem>
                    </div>

                    <FormItem>
                        <span class="yinsi" @click="yinsi">
                            隐私协议
                        </span>
                        <Button type="primary" @click="handleSubmit('formInline')">确认注册</Button>
                    </FormItem>
                </Form>
            </div>


        </Modal>

        <Modal v-model="yinsi_show" title="隐私协议" :footer-hide="true">

            <div v-html="yinsi_txt" style="height:400px;overflow:auto">

            </div>
        </Modal>

        <div class="kefu" @click="kefu">
            联系客服
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            login_show: false,
            regit_show: false,
            news_list: [
                {
                    title: "人力资源六大模块解读及流程图",
                    time: '2022-12-07',
                    price: "￥3",
                    value: "HR工作的航标兼导航仪 航行出海的船只都需要确立一个航标以定位目的地...招聘与配置 —“引”和“用”的结合艺术 人员任用讲求的是人岗匹配..."
                },
                {
                    title: "【HR必知】 70条人力资源学习知识汇总",
                    time: '2022-12-07',
                    price: "￥2",
                    value: "优点:激发员工的内在积极性;迅速的熟悉工作和进入工作;降低了招聘成本;保持企业内部的稳定性.缺点:容易形成企业内部人员的版块结构;可能引发企业高层..."
                },
                {
                    title: "【专业解密】人力资源管理,学习做伯乐的专业",
                    time: '2022-12-07',
                    price: "￥3",
                    value: "人力资源管理（120206）是工商管理下设的一个专业。1993年，中国人民大学将该校的人事管理专业改为人力资源管理，成为我国第一个人力资源管理本科专业。这个专业在我国开设的历史不是很长，但是开设院校比较多。据阳光高考平台统计，全国共有455所高校开设人力资源管理本科专业。..."
                },
                {
                    title: "收藏版 | 人力资源管控学习指导手册",
                    time: '2022-12-07',
                    price: "￥1",
                    value: "传统的单体公司人力资源管理主要是选育用留四项基本功能，但是在集团型公司里面,除了需要吸引人、使用人、培育人、发展人、留住人等单体公司也会拥有的职能以外,还应该考虑一些其他的什么内容呢？母公司高层的能力适合领导当下和未来的集团么？能力怎么进行发展？母公司高层负责宏观事务,怎么进行较有效的考核？怎么对他们进行短期和中长期激励？子公司高层的能力适合领导目前和今后一段时间里的子公司么？能力怎么进行发展?集团对派出的董事、监事、总经理、总监如何进行管理?..."
                },
                {
                    title: "人力资源如何保证组织学习能转化为结果?",
                    time: '2022-12-06',
                    price: "￥4",
                    value: "90后离职率高,该如何管理?花老师答:企业转型中,原有的人力资源结构受到挑战,该如何调整?..."
                },
                {
                    title: "人力资源管理,学管理,没人理?",
                    time: '2022-12-06',
                    price: "￥2",
                    value: "行动学习技术、企业全面经营模拟等课程. 培养目标:培养人力资源管理的复合型实用人才,既有岗位分析、招聘与录用、薪酬设计与..."
                },
                {
                    title: "纪创分享 | 人力资源六大板块,你知道多少!",
                    price: "￥3",
                    time: '2022-12-06',
                    value: "人力资源六大板块包含哪些?你知道多少?今天纪创君带你了解人力资源六大板块基础内容板块一 人力资源规划定义:企业从战略规划...."
                },

            ],
            formInline: {
                user: '',
                password: ''
            },
            ruleInline: {
                user: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { type: 'string', min: 6, message: 'The password length cannot be less than 6 bits', trigger: 'blur' }
                ]
            },
            yinsi_show: false,

            links: [
                {
                    key: '帮助',
                    title: '帮助',
                    href: 'https://www.iviewui.com',
                    blankTarget: true
                },
                {
                    key: 'github',
                    icon: 'logo-github',
                    href: 'https://github.com/view-design/ViewUIPlus',
                    blankTarget: true
                },
                {
                    key: '条款',
                    title: '条款',
                    href: '',
                    blankTarget: true
                }
            ],
            copyright: 'Copyright © 2022 View Design All Rights Reserved',
            yinsi_txt: "大湘速聘 隐私政策  </br>欢迎您访问我们的产品。  大湘速聘 （包括App及网站等产品提供的服务，以下简称“产品和服务”）是由  大湘速聘 （以下简称“我们”）开发并运营的。 确保用户的数据安全和隐私保护是我们的首要任务， 本隐私政策载明了您访问和使用我们的产品和服务时所收集的数据及其处理方式。  请您在继续使用我们的产品前务必认真仔细阅读并确认充分理解本隐私政策全部规则和要点， 一旦您选择使用，即视为您同意本隐私政策的全部内容，同意我们按其收集和使用您的相关信息。 如您在在阅读过程中，对本政策有任何疑问，可联系我们的客服咨询， 请通过  kefu@daxiangsys.com 或产品中的反馈方式与我们取得联系。 如您不同意相关协议或其中的任何条款的，您应停止使用我们的产品和服务。 </br>  本隐私政策帮助您了解以下内容：  </br> 一、我们如何收集和使用您的个人信息； </br>二、我们如何存储和保护您的个人信息； </br>三、我们如何共享、转让、公开披露您的个人信息； </br> 四、我们如何使用 Cookie 和其他追踪技术； </br>  一、我们如何收集和使用您的个人信息  个人信息是指以电子或者其他方式记录的能够单独或者与其他信息， 结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。 我们根据《中华人民共和国网络安全法》和《信息安全技术个人信息安全规范》（GB/T 35273-2017） 以及其它相关法律法规的要求，并严格遵循正当、合法、必要的原则， 出于您使用我们提供的服务和/或产品等过程中而收集和使用您的个人信息，包括但不限于电话号码等。  为接受我们全面的产品服务，您应首先注册一个用户账号，我们将通过它记录相关的数据。 您所提供的所有信息均来自于您本人在注册时提供的数据。 您准备使用的账户名、密码、您本人的联系方式， 我们可能通过发短信或者邮件的方式来验证您的身份是否有效。  二、我们如何存储和保护您的个人信息  作为一般规则，我们仅在实现信息收集目的所需的时间内保留您的个人信息。 我们会在对于管理与您之间的关系严格必要的时间内保留您的个人信息 （例如，当您开立帐户，从我们的产品获取服务时）。 出于遵守法律义务或为证明某项权利或合同满足适用的诉讼时效要求的目的， 我们可能需要在上述期限到期后保留您存档的个人信息，并且无法按您的要求删除。  当您的个人信息对于我们的法定义务或法定时效对应的目的或档案不再必要时， 我们确保将其完全删除或匿名化。  值得一提的是，为了加强对隐私数据的保护，我们在收集时就已对其进行了脱敏处理， 即使在我们自己的数据库中，也不会储存具有关联性的、明文的隐私数据。  三、我们如何共享、转让、公开披露您的个人信息  在管理我们的日常业务活动所需要时，为追求合法利益以更好地服务客户， 我们将合规且恰当的使用您的个人信息。出于对业务和各个方面的综合考虑， 我们仅自身使用这些数据，不与任何第三方分享。  我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。 在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。 我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。  在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意： 1、与国家安全、国防安全直接相关的；2、与犯罪侦查、起诉、审判和判决执行等直接相关的； 3、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； 4、您自行向社会公众公开的个人信息； 5、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。 6、根据个人信息主体要求签订和履行合同所必需的； 7、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障； 8、法律法规规定的其他情形。 四、我们如何使用 Cookie 和其他追踪技术  为确保产品正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。 Cookie 通常包含标识符、产品名称以及一些号码和字符。 借助于 Cookie，我们能够存储您的偏好或商品等数据，并用以判断注册用户是否已经登录， 提升服务和产品质量及优化用户体验。  我们出于不同的目的使用各种Cookie，包括：严格必要型Cookie、性能Cookie、营销Cookie和功能Cookie。 某些Cookie可能由外部第三方提供，以向我们的产品提供其它功能。 我们不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。 您可以清除计算机上或手机中保存的所有 Cookie，大部分网络浏览器都设有阻止或禁用 Cookie 的功能， 您可对浏览器进行配置。阻止或禁用 Cookie 功能后，可能影响您使用或不能充分使用我们的产品和服务。 "

        }
    },
    methods: {
        kefu() {
            alert('客服电话:13835933646')
        },

        yinsi() {
            this.yinsi_show = true
        },

        gengduo2() {
            this.$Message.error('请先登录哟')
        },

        click_news(item) {
            this.login_show = true
            this.$Message.error('请登录后再进行购买')
        },

        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$Message.success('Success!');
                } else {
                    this.$Message.error('Fail!');
                }
            })
        }
    }
}
</script>

<style  scoped>
.kefu {
    cursor: pointer;
    width: 50px;
    position: absolute;
    right: 0;
    padding: 10px;
    bottom: 50%;
    background-color: #4466dd;
    border-radius: 5px;
    color: #fff;
}

.yinsi {
    font-size: 13px;
    cursor: pointer;
}

.time2 {
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    color: #ccc;
}

.gengduo {
    text-align: center;
    color: #ccc;
    cursor: pointer;
    font-size: 14px;
    padding: 20px;
    ;
}

.login_box {
    text-align: center;
}

.price {
    float: right;
    font-size: 15px;
    font-weight: 600;
    color: rgb(255, 99, 2);
}

.kefu2 {
    margin-bottom: 20px;
    color: #fff;
}

.kefu13 {
    margin: 10px;
    color: #fff;
    cursor: pointer;
}

.kefu13:hover {
    color: #4466dd;
}

.kefu3 {
    margin: 10px;
}

.new_main {
    width: 1200px;
    margin-left: calc(50% - 600px);
    display: flex;
    justify-content: center;
    padding: 20px;
    flex-wrap: wrap;
    min-height: 1000px;
}

.head_title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
}

.head {
    background-color: #4466dd;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
}

.card_title {
    font-weight: 600;
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
}

.card_main {
    background-color: #ececec;
    min-height: 100vh;
    text-align: center;

}

.login {
    background-color: #5f99df;
    padding: 3px 20px;
    border-radius: 3px;
    ;
    font-size: 14px;
    cursor: pointer;
    ;
    color: #fff;
}

.floor {
    background-color: #333;
    height: 200px;
    padding: 50px;
}

.newcard {
    margin-right: 10px;
    padding: 20px;
    text-align: left;
    width: 700px;
    background-color: #ffff;
    cursor: pointer;
    margin-bottom: 10px;
}
</style>